var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "merchant-application-detail" },
    [
      _c("div", { staticClass: "page-title application-detail-header" }, [
        _vm._v(" " + _vm._s(_vm.$t("developer.application_setting")) + " "),
      ]),
      !_vm.$store.getters.isID
        ? _c("div", { staticClass: "application-detail-switch" }, [
            _c(
              "div",
              { staticClass: "grid-content bg-purple-light" },
              [
                _c(
                  "el-row",
                  { staticClass: "switch-class" },
                  [
                    _c("el-col", { attrs: { span: 5 } }, [
                      _c(
                        "div",
                        { staticClass: "grid-content bg-purple-light" },
                        [
                          _c(
                            "p",
                            { staticClass: "setting-title" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "developer.shared_application_setting"
                                    )
                                  ) +
                                  " "
                              ),
                              _c(
                                "el-tooltip",
                                { attrs: { placement: "top" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { width: "300px" },
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "tips.shared_application_setting_tips"
                                            )
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("svg-icon", {
                                    staticClass: "icon-question-tip",
                                    attrs: {
                                      "icon-class": "icon-blue-question",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]),
                    _c(
                      "el-col",
                      { attrs: { span: 19 } },
                      [
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-value": 1,
                              "inactive-value": 2,
                              "active-text":
                                _vm.sharePublicKeyStatus === 1
                                  ? "Open"
                                  : "Close",
                              "active-color": "#67C23A",
                              "inactive-color": "#F56C6C",
                              disabled: !_vm.publicKeyFlag,
                            },
                            on: { change: _vm.changeSharePublicKeyStatus },
                            model: {
                              value: _vm.sharePublicKeyStatus,
                              callback: function ($$v) {
                                _vm.sharePublicKeyStatus = $$v
                              },
                              expression: "sharePublicKeyStatus",
                            },
                          }),
                        ],
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticClass: "application-detail-application" },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 5 } }, [
                _c("div", { staticClass: "grid-content bg-purple" }, [
                  _c("p", { staticClass: "setting-title" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("developer.application_information")) +
                        " "
                    ),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 19 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 5 } }, [
                          _c("div", { staticClass: "grid-content bg-purple" }, [
                            _c("p", { staticClass: "setting-key" }, [
                              _vm._v("AppId:"),
                            ]),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 16 } }, [
                          _c("div", { staticClass: "grid-content bg-purple" }, [
                            _c("p", { staticClass: "setting-value" }, [
                              _vm._v(_vm._s(_vm.application.app_id)),
                            ]),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c("div", { staticClass: "grid-content bg-purple" }),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "application-detail-webhook" },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 5 } }, [
                _c("div", { staticClass: "grid-content bg-purple" }, [
                  _c("p", { staticClass: "setting-title" }, [
                    _vm._v("Webhook"),
                  ]),
                ]),
              ]),
              _c("el-col", { attrs: { span: 19 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 5 } }, [
                          _c("div", { staticClass: "grid-content bg-purple" }, [
                            _c("p", { staticClass: "setting-key" }, [
                              _vm._v("Pay out:"),
                            ]),
                          ]),
                        ]),
                        _c("el-col", { attrs: { span: 16 } }, [
                          _c(
                            "div",
                            { staticClass: "grid-content bg-purple" },
                            [
                              !_vm.noticeWebhookFlag
                                ? _c("p", { staticClass: "setting-value" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.application.notice_webhook
                                          ? _vm.application.notice_webhook
                                          : ""
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.noticeWebhookFlag
                                ? _c("el-input", {
                                    staticClass: "search-frame",
                                    attrs: {
                                      placeholder: _vm.$t(
                                        "merchant.notice_webhook"
                                      ),
                                    },
                                    model: {
                                      value: _vm.webhookForm.notice_webhook,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.webhookForm,
                                          "notice_webhook",
                                          $$v
                                        )
                                      },
                                      expression: "webhookForm.notice_webhook",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c(
                            "div",
                            { staticClass: "grid-content bg-purple" },
                            [
                              _c(
                                "el-tooltip",
                                { attrs: { placement: "top" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("components.edit"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                    ]
                                  ),
                                  !_vm.noticeWebhookFlag
                                    ? _c("i", {
                                        staticClass:
                                          "el-icon-edit setting-value icon-hover",
                                        on: {
                                          click: function ($event) {
                                            return _vm.changeWebhookInput(1)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _c(
                                "el-tooltip",
                                { attrs: { placement: "top" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("components.submit"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                    ]
                                  ),
                                  _vm.noticeWebhookFlag
                                    ? _c("el-button", {
                                        staticClass: "submit-btn",
                                        attrs: {
                                          type: "primary",
                                          icon: "el-icon-edit",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.submitMchWebhook(1)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                    _vm.$store.getters.isID
                      ? _c(
                          "el-row",
                          [
                            _c("el-col", { attrs: { span: 7 } }, [
                              _c(
                                "div",
                                { staticClass: "grid-content bg-purple" },
                                [
                                  _c("p", { staticClass: "setting-key" }, [
                                    _vm._v(
                                      "Static VA Collection Verification URL:"
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                            _c("el-col", { attrs: { span: 14 } }, [
                              _c(
                                "div",
                                { staticClass: "grid-content bg-purple" },
                                [
                                  !_vm.staticVAFlag
                                    ? _c(
                                        "p",
                                        { staticClass: "setting-value" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.application.validate_url
                                                ? _vm.application.validate_url
                                                : ""
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.staticVAFlag
                                    ? _c("el-input", {
                                        staticClass: "search-frame",
                                        model: {
                                          value: _vm.webhookForm.validate_url,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.webhookForm,
                                              "validate_url",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "webhookForm.validate_url",
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                            _c("el-col", { attrs: { span: 3 } }, [
                              _c(
                                "div",
                                { staticClass: "grid-content bg-purple" },
                                [
                                  _c(
                                    "el-tooltip",
                                    { attrs: { placement: "top" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("components.edit")
                                                )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("br"),
                                        ]
                                      ),
                                      !_vm.staticVAFlag
                                        ? _c("i", {
                                            staticClass:
                                              "el-icon-edit setting-value icon-hover",
                                            on: {
                                              click: function ($event) {
                                                return _vm.changeWebhookInput(4)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "el-tooltip",
                                    { attrs: { placement: "top" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("components.submit")
                                                )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("br"),
                                        ]
                                      ),
                                      _vm.staticVAFlag
                                        ? _c("el-button", {
                                            staticClass: "submit-btn",
                                            attrs: {
                                              type: "primary",
                                              icon: "el-icon-edit",
                                              circle: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.submitMchWebhook(4)
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "application-detail-apiKey" },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 5 } }, [
                _c("div", { staticClass: "grid-content bg-purple" }, [
                  _c("p", { staticClass: "setting-title" }, [
                    _vm._v("API Key"),
                  ]),
                  _c(
                    "div",
                    { staticStyle: { width: "80%", "margin-top": "20px" } },
                    [
                      _c("p", { staticClass: "setting-title-dec" }, [
                        _vm._v(_vm._s(_vm.$t("tips.public_key_introduce"))),
                      ]),
                    ]
                  ),
                ]),
              ]),
              _c("el-col", { attrs: { span: 19 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 5 } }, [
                          _c(
                            "div",
                            { staticClass: "grid-content bg-purple-light" },
                            [
                              _c("p", { staticClass: "setting-key" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("developer.public_key")) +
                                    ":"
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 16 } }, [
                          _c(
                            "div",
                            { staticClass: "grid-content bg-purple-light" },
                            [
                              !_vm.publicKeyInputFlag
                                ? _c("p", { staticClass: "setting-value" }, [
                                    _vm._v(_vm._s(_vm.hiddenInfo.public_key)),
                                  ])
                                : _vm._e(),
                              _vm.publicKeyInputFlag
                                ? _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      rows: 8,
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.hiddenForm.public_key,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.hiddenForm,
                                          "public_key",
                                          $$v
                                        )
                                      },
                                      expression: "hiddenForm.public_key",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c(
                            "div",
                            { staticClass: "grid-content bg-purple-light" },
                            [
                              _c(
                                "el-tooltip",
                                { attrs: { placement: "top" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("components.view"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                    ]
                                  ),
                                  !_vm.publicKeyFlag
                                    ? _c("i", {
                                        staticClass:
                                          "el-icon-view setting-value icon-hover",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showUserAuthenticationModal(
                                              "public_key_second"
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm.publicKeyFlag && !_vm.publicKeyInputFlag
                                ? _c("i", {
                                    staticClass:
                                      "el-icon-edit setting-value icon-hover",
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeHiddenInput(1)
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm.publicKeyInputFlag
                                ? _c("el-button", {
                                    staticClass: "submit-btn",
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-edit",
                                      circle: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.submitReSetPublicSecret(1)
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "application-detail-ip" },
        [
          _c(
            "el-row",
            [
              _c("el-col", { attrs: { span: 5 } }, [
                _c("div", { staticClass: "grid-content bg-purple" }, [
                  _c(
                    "p",
                    { staticClass: "setting-title" },
                    [
                      _vm._v(_vm._s(_vm.$t("developer.ip_white_list")) + " "),
                      _c(
                        "el-tooltip",
                        { attrs: { placement: "top" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: { width: "300px" },
                              attrs: { slot: "content" },
                              slot: "content",
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("tips.ip_white_paycools_introduce")
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _c("svg-icon", {
                            staticClass: "icon-question-tip",
                            attrs: { "icon-class": "icon-blue-question" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _c("el-col", { attrs: { span: 19 } }, [
                _c(
                  "div",
                  { staticClass: "grid-content bg-purple-light" },
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 5 } }, [
                          _c(
                            "div",
                            { staticClass: "grid-content bg-purple-light" },
                            [
                              _c("p", { staticClass: "setting-key" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("developer.ip_address")) + ":"
                                ),
                              ]),
                            ]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 16 } }, [
                          _c(
                            "div",
                            { staticClass: "grid-content bg-purple-light" },
                            [
                              !_vm.ipKeyInputFlag
                                ? _c("p", { staticClass: "setting-value" }, [
                                    _vm._v(_vm._s(_vm.hiddenInfo.white_ips)),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _c("el-col", { attrs: { span: 3 } }, [
                          _c(
                            "div",
                            { staticClass: "grid-content bg-purple-light" },
                            [
                              _c(
                                "el-tooltip",
                                { attrs: { placement: "top" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "content" },
                                      slot: "content",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.$t("components.view"))
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                    ]
                                  ),
                                  !_vm.ipKeyFlag
                                    ? _c("i", {
                                        staticClass: "el-icon-view icon-hover",
                                        on: {
                                          click: function ($event) {
                                            return _vm.showUserAuthenticationModal(
                                              "white_ips_second"
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("developer.shared_application_setting"),
            visible: _vm.dialogVisible,
            width: "30%",
            "before-close": _vm.closeSharePublicKeyDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("p", { staticStyle: { "margin-bottom": "50px" } }, [
            _vm._v(_vm._s(_vm.$t("tips.share_public_key_introduce"))),
          ]),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { on: { click: _vm.closeSharePublicKeyDialog } },
                [_vm._v(_vm._s(_vm.$t("components.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitSharePublicKey()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("components.confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _c("AppIdentityEmailCheckModal", {
        ref: "identityCheckPublicKeyRef",
        attrs: { app_id_second: _vm.checkType },
        on: { showHiddenInfo: _vm.showHiddenInfo },
      }),
      _c("AppIdentityEmailCheckModal", {
        ref: "identityCheckWhiteIpsRef",
        attrs: { app_id_second: _vm.checkType },
        on: { showHiddenInfo: _vm.showHiddenInfo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }